import { useRealTimeData } from "../hooks/useRealTimeData"
import AlertsTable from "../components/AlertsTable"
import MapView from "../components/MapView"
import { Activity, AlertTriangle, MapPin, Battery } from "lucide-react"

const DashboardPage = () => {
  const { devices, alerts, acknowledgeAlert } = useRealTimeData()

  const stats = {
    totalDevices: devices.length,
    activeDevices: devices.filter((d) => d.status === "active").length,
    criticalAlerts: alerts.filter((a) => a.severity === "critical" && !a.acknowledged).length,
    avgBattery: Math.round(devices.reduce((sum, d) => sum + d.battery, 0) / devices.length) || 0,
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Security Dashboard</h1>
        <p className="text-gray-600">Monitor your IoT explosive detection network in real-time</p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="card">
          <div className="p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-md bg-blue-100 text-blue-600">
                <MapPin className="h-6 w-6" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">Total Devices</dt>
                  <dd className="text-lg font-semibold text-gray-900">{stats.totalDevices}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-md bg-green-100 text-green-600">
                <Activity className="h-6 w-6" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">Active Devices</dt>
                  <dd className="text-lg font-semibold text-gray-900">{stats.activeDevices}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-md bg-red-100 text-red-600">
                <AlertTriangle className="h-6 w-6" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">Critical Alerts</dt>
                  <dd className="text-lg font-semibold text-gray-900">{stats.criticalAlerts}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="p-6">
            <div className="flex items-center">
              <div className="p-3 rounded-md bg-yellow-100 text-yellow-600">
                <Battery className="h-6 w-6" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">Avg Battery</dt>
                  <dd className="text-lg font-semibold text-gray-900">{stats.avgBattery}%</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map and Alerts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Device Locations</h3>
            <p className="card-subtitle">Real-time device status and alerts</p>
          </div>
          <div className="h-96">
            <MapView devices={devices} alerts={alerts} />
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Recent Alerts</h3>
            <p className="card-subtitle">Latest security notifications</p>
          </div>
          <div className="max-h-96 overflow-y-auto custom-scrollbar">
            <AlertsTable alerts={alerts.slice(0, 5)} onAcknowledge={acknowledgeAlert} compact={true} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardPage

